(() => {
  const filterNodes = {
    container: document.getElementById('collection-container') || document.getElementById('search-container'),
    parent: document.getElementById('storefront-filters-parent'),
    collectionBanner: document.querySelector('[data-collectionBanner]'),
    quickShopModal: document.querySelector('quick-shop'),
    templateType: document.getElementById('collection-container')?.getAttribute('data-template'),
  }
  
  class storefrontFilters {
    constructor() {
      this.gridsContainer = filterNodes.container.querySelector('#products-listing');
      this.paginate = filterNodes.container.querySelector('[data-paginationParent]');

      // For top-18 template, only initialize infinite scroll
      if (filterNodes.templateType === 'top-18-collection') {
        this.isLoading = false;
        this.initInfiniteScroll();
        return;
      }

      // For other templates, initialize both filters and infinite scroll
      if(!filterNodes.container || !filterNodes.parent) return;
  
      this.form = filterNodes.container.querySelector('#storefront-filters-form');
      this.drawer = filterNodes.parent.querySelector('#storefront-filter-drawer');
      this.drawerFooter = filterNodes.parent.querySelector('[data-filterFooter]'),
  
      this.debouncedOnSubmit = Utility.debounce((event) => this.onSubmitHandler(event), 500);
  
      if (this.form) {
        this.form.addEventListener('input', (evt) => {
          const element = evt.target || evt.currentTarget;
          if (element.type === 'range' || (element.name != 'sort_by' && window.innerWidth < 992)) return;
          this.debouncedOnSubmit(evt);
        });
        this.form.addEventListener('submit', this.debouncedOnSubmit.bind(this));
      }
      
      this.manageDrawerUI(window.innerWidth);
      this.bindEvents();
      this.dynamicEleEvents();

      // Add this new code to handle initial filter state
      this.handleInitialFilterState();

      this.isLoading = false;
      this.initInfiniteScroll();
    }

    handleInitialFilterState() {
      const urlParams = new URLSearchParams(window.location.search);
      const sideFilterBtn = document.querySelector('[data-sideFilter]');
      if (sideFilterBtn && Array.from(urlParams.keys()).some(key => key.startsWith('filter.'))) {
        document.querySelector(".product-listing-main-wrapper").classList.add("filters-open");
        sideFilterBtn.classList.add("filters-open");
      }
      for (const [key, value] of urlParams.entries()) {
        if (key.startsWith('filter.')) {
          // Handle multiple values for the same filter
          const values = urlParams.getAll(key);
          values.forEach(filterValue => {
            const filterInput = this.form.querySelector(`input[name="${key}"][value="${filterValue}"]`);
            if (filterInput) {
              filterInput.checked = true;
              // Find and open the parent accordion panel
              const panel = filterInput.closest('[is="collapsiblePanel"]');
              if (panel) {
                panel.classList.add('open');
                const contentBlock = panel.querySelector('.filter__block.panel_content');
                if (contentBlock) {
                  contentBlock.classList.add('open');
                  contentBlock.setAttribute('aria-hidden', 'false');
                }
                const toggleButton = panel.querySelector('[data-toggle="panel"]');
                if (toggleButton) {
                  toggleButton.setAttribute('aria-expanded', 'true');
                }
              }
            }
          });
        }
      }
    }
    
    initInfiniteScroll() {
      if (!this.paginate) return;

      const options = {
        root: null,
        rootMargin: "1200px", // Increased margin to load much earlier
        threshold: 0.08, // Keep a lower threshold for earlier detection
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoading) {
            const nextPageLink = this.gridsContainer.querySelector('[data-loadmore]');
            if (nextPageLink) {
              this._managePagination({ 
                preventDefault: () => {},
                currentTarget: nextPageLink
              });
            }
          }
        });
      }, options);

      // Create and observe a sentinel element
      const sentinel = document.createElement('div');
      sentinel.className = 'scroll-sentinel';
      this.gridsContainer.appendChild(sentinel);
      observer.observe(sentinel);

      // Update sentinel position when window is resized
      window.addEventListener('resize', () => {
          if (sentinel) {
              observer.unobserve(sentinel);
              observer.observe(sentinel);
          }
      });
    }

    /**
     * Switch between Drawer/Colume view 
    */
    manageDrawerUI(windowWidth){
      let filterGrid = filterNodes.parent.querySelector('#storefront-filter-grid');
      const elementToClone = filterGrid;
  
      filterGrid.remove();
  
      if(windowWidth >= 992){
        this.drawer.parentNode.appendChild(elementToClone);
        // this.drawer.closeDrawer();
      }else{
        this.drawer.querySelector('div.drawer-body').appendChild(elementToClone);
      }
      filterGrid = elementToClone;
    }
  
    /**
     * bind events to UI element events
    */
    bindEvents() {
      window.onresize = () => {
        this.manageDrawerUI(window.innerWidth);
      };
  
      const sortbyDesktop = filterNodes.container.querySelectorAll('#sortby-dropdown .sortby_options');
      sortbyDesktop.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));
  
      const paginateByValues = filterNodes.container.querySelectorAll('#products-per-page [name="paginateBy"]');
      paginateByValues.forEach(input => input.addEventListener('change', this.paginateProductsBy.bind(this)));
  
      const closeFilters = filterNodes.parent.querySelectorAll('[data-closefilter]');
      closeFilters.forEach(btn => { 
        btn.addEventListener('click', (evt)=>{
          evt.preventDefault();
          let drawer = evt.currentTarget.closest('custom-drawer');
          if(drawer){
            // Close the drawer
            const closeDrawerButton = drawer.querySelector('[data-closedrawer]');
            closeDrawerButton?.click();
  
            // Find the open collapsible panel and toggle it
            const openPanel = drawer.querySelector('[is="collapsiblePanel"].open');
            const toggleButton = openPanel?.querySelector('[data-toggle="panel"]');
            toggleButton?.click();
          }
        });
      });
      const backFilters = filterNodes.parent.querySelectorAll('[data-back]');
      backFilters.forEach(btn => { 
        btn.addEventListener('click', (evt)=>{
          evt.preventDefault();
          let panel = evt.currentTarget.closest('[is="collapsiblePanel"]');
          panel?.querySelector('[data-toggle="panel"]')?.click();
        });
      });
    }
  
    dynamicEleEvents() {
      const collectionLinks = filterNodes.parent.querySelectorAll('[data-subcollectionslinks]');
      collectionLinks.forEach(link => link.addEventListener('click', this._manageSubCollections.bind(this)));
  
      if (filterNodes.quickShopModal?.bindEvents) filterNodes.quickShopModal.bindEvents();
  
      const applyBtn = filterNodes.parent.querySelector('[data-applyFilters]');
      applyBtn?.addEventListener('click', () => {
        const searchParams = this._createQueryString(this.form)
        this.renderPage(searchParams);
      });
  
      const paginationLinks = filterNodes.container.querySelectorAll('[data-pagelinks]');
      paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));
  
      this.colorOptionsStyling();
      this.bindActiveFilterButtonEvents();
    }
  
    /**
     * Filter form submit event
     */
    onSubmitHandler(event) {
      event.preventDefault();
      const searchParams = this._createQueryString(this.form)
      this.renderPage(searchParams);
    }
  
    /**
     * click event To Remove current selections
     * @param {element} form Collection page filter form
     */
    _createQueryString(form){
      const formData = new FormData(form);
      const priceGTE = form.querySelector('[name="filter.v.price.gte"]');
      const priceLTE = form.querySelector('[name="filter.v.price.lte"]');
  
      if (priceGTE && priceGTE.min === formData.get('filter.v.price.gte')) {
        formData.delete('filter.v.price.gte');
      }
      if (priceLTE && priceLTE.max === formData.get('filter.v.price.lte')) {
        formData.delete('filter.v.price.lte');
      }
      return new URLSearchParams(Array.from(formData)).toString();
    }
  
    /**
     * 
     * @param {String} searchParams Query Parameters
     * @param {Boolean} updateURLHash true/false
    */
    async renderPage(searchParams, updateURLHash = true) {
      this.gridsContainer.classList.add('loading');
  
      const url = `${window.location.pathname}?${searchParams}`;
      await this.renderGridFromFetch(url, 'filter');
  
      if (updateURLHash) this.updateURLHash(searchParams);
    }
  
    /**
     * Add background color in label of Color options
     */
    colorOptionsStyling(){
      const colorSwatchContainer = filterNodes.parent.querySelector('[data-colorFilter]');
      if(!colorSwatchContainer) return;
  
      colorSwatchContainer.querySelectorAll('.color-options').forEach(swatch => {
        const colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
        const swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
      });
    }
  
    /**
     * Remove active filters
     */
     onActiveFilterClick(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
  
      const URLString = new URL(event.currentTarget.href).searchParams.toString();
      if(URLString != null) this.renderPage(URLString);
    }
  
     /**
     * Update Window URL
     */
    onHistoryChange(event) {
      const searchParams = event.state?.searchParams || '';
      this.renderPage(searchParams, false);
    }
  
    /**
     * 
     * @param {String} url URL for fetching results
     * @param {String} type filter / pagination / sub_collection
     */
    async renderGridFromFetch(url, type) {
      if(!url) return;
  
      const sectionID = filterNodes.container.dataset.section;
      url += type === 'sub_collection' ? `&sections=${sectionID},template-collection-banner` : `&sections=${sectionID}`;
  
      try {
        const response = await fetch(url);
        const data = await response.json();
        const gridHTML = data[sectionID];
        const bannerHTML = data['template-collection-banner'];
        this.renderProductGrid(type, gridHTML, bannerHTML);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  
    /**
     * 
     * @param {HTMlResponse} html 
     * @param {String} type filter / pagination / sub_collection
     */
    renderProductGrid(type, grid, banner) {
      const html = new DOMParser().parseFromString(grid, 'text/html');
      const filterPanels = html.querySelectorAll('#storefront-filters-form .individual-filter-block');
      const paginationType = this.paginate?.dataset.type || 'numbers';
      const productGrids = this.gridsContainer.querySelector('[data-products-grid');
      const loadMoreBtn = this.gridsContainer.querySelector('[data-loadmore]');

      if (type === 'pagination' && paginationType === 'loadmore') {
          productGrids.insertAdjacentHTML('beforeend', html.querySelector('[data-products-grid]').innerHTML);
          const newLoadMoreBtn = html.querySelector('[data-loadmore]');
          if (newLoadMoreBtn && loadMoreBtn) {
              loadMoreBtn.parentNode.replaceChild(newLoadMoreBtn, loadMoreBtn);
          } else if (loadMoreBtn) {
              loadMoreBtn.remove();
          }
      } else {
        this.gridsContainer.innerHTML = html.querySelector('#products-listing').innerHTML;
      }
       if (typeof lazyImageObserver !== 'undefined' && lazyImageObserver?.observe) {
        lazyImageObserver.observe();
      }
      
      if (filterNodes.templateType != 'top-18-collection') {
        // Manage filter panels display
        let filterBlocks = document.querySelectorAll('#storefront-filters-form .individual-filter-block');
        filterBlocks.forEach(panel => panel.classList.add('d-none'));
    
        filterPanels.forEach(panel => {
          const filterBlock = document.querySelector(`.individual-filter-block[data-index="${panel.dataset.index}"]`);
          if (filterBlock) {
              filterBlock.querySelector('.filter__block').innerHTML = panel.querySelector('.filter__block').innerHTML;
              filterBlock.classList.remove('d-none');
          }
        });
        if(filterNodes.parent.dataset.layout == 'topbar'){
          this.form.querySelector('.individual-filter-block.open[is="collapsiblePanel"]')?.querySelector('[data-toggle="panel"]').click();
        }

        const activeFilterTotalProduct = ['.desktop-total-prod', '.mobile-total-prod'];
        activeFilterTotalProduct.forEach(selector => {
          const newProductTotal = html.querySelector(selector);
          const existingProdTotal = document.querySelector(selector);
          if (newProductTotal && existingProdTotal) {
            existingProdTotal.innerHTML = newProductTotal.innerHTML;
          }
        });
    
        this.drawerFooter.innerHTML = html.querySelector('[data-filterFooter]').innerHTML; // Update drawer footer

        // Update active filters
        const activeFilterSelectors = ['.desktop-active-filter [data-activeFilters]', '.mobile-active-filter [data-activeFilters]'];
        activeFilterSelectors.forEach(selector => {
          const newActiveFilter = html.querySelector(selector);
          const existingActiveFilter = document.querySelector(selector);
          if (newActiveFilter && existingActiveFilter) {
            existingActiveFilter.innerHTML = newActiveFilter.innerHTML;
          }
        });
    
        if (type === 'sub_collection' && filterNodes.collectionBanner && banner) {  // Change banner on subcollection
          const bannerNode = new DOMParser().parseFromString(banner, 'text/html');
          filterNodes.collectionBanner.innerHTML = bannerNode.querySelector('[data-collectionBanner]').innerHTML;
        }
      }
  
      this.dynamicEleEvents();
      if (this.drawer?.isOpen) this.drawer.closeDrawer(); // Close drawer if open

      // Add this line to reinitialize infinite scroll after content updates
      this.initInfiniteScroll();
    }

    /**
     * Re-Binding events on active filters after ajax request
     */
    bindActiveFilterButtonEvents() {
      const removeActiveFilters = Array.from(document.getElementsByClassName('filter-option-clear'));
      removeActiveFilters.forEach((element) => {
        element.addEventListener('click', this.onActiveFilterClick.bind(this), { once: true });
      });
    }
  
    /**
     * Update the url
     * @param {String} searchParams 
     */
    updateURLHash(searchParams) {
      window.history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  
    updateSortBy(event){
      const currentEle = event.currentTarget;
      const targetOpt = this.form.querySelector(`input[name="sort_by"][value="${currentEle.value}"]`);
      if(targetOpt){
        targetOpt.checked = true;
        this.form.dispatchEvent(new Event('input', { once: true }));
      }
    }
  
    async paginateProductsBy(event){
      event.preventDefault();
      const currentValue = document.querySelector('#products-per-page [name="paginateBy"]:checked').value;
      const requestData = { attributes: { 'products_per_page': currentValue } };
  
      try {
        await fetch("/cart/update", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(requestData),
        });
        const searchParams = this._createQueryString(this.form);
        const url = `${window.location.pathname}?${searchParams}`;
        await this.renderGridFromFetch(url, 'pagination');
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }
  
    async _manageSubCollections(event){
      event.preventDefault();
      const _this =  event.currentTarget;
      const queryString = this._createQueryString(this.form);
      const collURL = `${_this.href  }?${  queryString}`;
      await this.renderGridFromFetch(collURL, 'sub_collection');
  
      setTimeout(() => {
        window.history.pushState({}, '', collURL);
      }, 500);
    }
  
    async _managePagination(event){
      event.preventDefault();
      const _this = event.currentTarget;
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        await this.renderGridFromFetch(_this.href, "pagination");
      } finally {
        this.isLoading = false;
      }
  
      const paginationType = _this.closest('[data-paginationparent]')?.dataset.type || 'numbers';
      if(paginationType != 'loadmore'){
        setTimeout(() => {
          // window.history.pushState({}, '', _this.href);
        }, 500);
      }
    }
  }
  if (typeof storefrontFilters !== 'undefined') new storefrontFilters();
  })();
  
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      
      this.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]')
        .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
  
      this.setMinAndMaxValues();
      this.manageSliderChange();
    }
  
    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }
  
    setMinAndMaxValues() {
      const inputs = this.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]');
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  
    // eslint-disable-next-line class-methods-use-this
    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('min'));
      const max = Number(input.getAttribute('max'));
  
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  
    // eslint-disable-next-line class-methods-use-this
    manageSliderChange() {
      const sliderSection = this.querySelector("#range-slider");
      const sliders = sliderSection.getElementsByTagName("input");
      Array.from(sliders).forEach(slider => {
        slider.oninput = () => {
          let slide1 = Number(sliders[0].value);
          let slide2 = Number(sliders[1].value);
  
          // Neither slider will clip the other, so make sure we determine which is larger
          if( slide1 > slide2 ){ const tmp = slide2; slide2 = slide1; slide1 = tmp; }
          this.querySelector('input[name="filter.v.price.gte"]').value = slide1;
          this.querySelector('input[name="filter.v.price.lte"]').value = slide2;
        }
        slider.onchange = () =>{
          if(window.innerWidth >= 992) this.closest('form').dispatchEvent(new CustomEvent('submit'));
        }
      });
    }
  }
  customElements.define('price-range', PriceRange);


  class customCollectionJS {
    constructor() {
      if (document.querySelector('[data-sideFilter]')) {
        this.showFilters();
      }
    }
    
    showFilters(){
        document.querySelector('[data-sideFilter]').addEventListener('click' , event => {
          event.preventDefault();
          document.querySelector(".product-listing-main-wrapper").classList.toggle("filters-open");
          document.querySelector('[data-sideFilter]').classList.toggle("filters-open"); 
        })
    }
  }
  
  typeof customCollectionJS !== 'undefined' && new customCollectionJS();